import { CellSize } from 'bold-ui'

import { AgendarConsultaCellSizes } from './model-agendarConsultaAtendimento'

export function getRegistroTardioCellSizes(
  hasPainelLateral: boolean,
  showHorarioFinal: boolean
): AgendarConsultaCellSizes {
  return {
    lotacao: {
      md: 4,
      lg: 4,
    },
    emptyCell: {
      md: 8,
      lg: 8,
    },
    data: {
      md: 3,
      lg: getDataLgSize(showHorarioFinal, hasPainelLateral),
    },
    horarios: {
      md: 3,
      lg: getHorariosLgSize(showHorarioFinal, hasPainelLateral),
    },
  }
}

export function getAtendimentoCellSizes(
  hasPainelLateral: boolean,
  showHorarioFinal: boolean
): AgendarConsultaCellSizes {
  return {
    lotacao: {
      md: 6,
      lg: hasPainelLateral ? 6 : 5,
    },
    emptyCell: {
      md: 6,
      lg: hasPainelLateral ? 6 : 7,
    },
    data: {
      md: 3,
      lg: getDataLgSize(showHorarioFinal, hasPainelLateral),
    },
    horarios: {
      md: 3,
      lg: getHorariosLgSize(showHorarioFinal, hasPainelLateral),
    },
  }
}

function getDataLgSize(showHorarioFinal: boolean, hasPainelLateral: boolean): CellSize {
  if (showHorarioFinal) {
    return 2
  } else {
    return hasPainelLateral ? 3 : 2
  }
}

function getHorariosLgSize(showHorarioFinal: boolean, hasPainelLateral: boolean): CellSize {
  if (showHorarioFinal) {
    return hasPainelLateral ? 4 : 3
  } else {
    return hasPainelLateral ? 3 : 2
  }
}
